import { render, staticRenderFns } from "./muscledetails.vue?vue&type=template&id=5df35c3d&scoped=true"
import script from "./muscledetails.vue?vue&type=script&lang=js"
export * from "./muscledetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df35c3d",
  null
  
)

export default component.exports